import CustomerRelatedFieldsModelMC from '../data/models/customers/relatedFieldsModel';

export const createField = (params) => async (dispatch) => {
  try {
    const data = await CustomerRelatedFieldsModelMC.save(params);
    return data;
  } catch (err) {
    dispatch({ type: 'LOAD_DATA_FAILURE', err });
    throw err;
  }
};

export const updateField = (params) => async (dispatch) => {
  try {
    const data = await CustomerRelatedFieldsModelMC.save(params);
    return data;
  } catch (err) {
    dispatch({ type: 'LOAD_DATA_FAILURE', err });
    throw err;
  }
};
